import { Gender } from '~entities/student/modal/student';

import type { FormConfigField } from '~shared/api/form-config';

export const DEFAULT_FORM_FIELD: Array<FormConfigField> = [
  {
    fieldId: 'firstName',
    label: 'First Name',
    section: 'General Info',
    order: 1,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'lastName',
    label: 'Last Name',
    section: 'General Info',
    order: 2,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'email',
    label: 'Email',
    section: 'General Info',
    order: 3,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'relation',
    label: 'Relation',
    section: 'General Info',
    order: 4,
    required: false,
    type: 'select',
    options: [
      {
        value: 'father',
        label: 'Father',
      },
      {
        value: 'mother',
        label: 'Mother',
      },
      {
        value: 'guardian',
        label: 'Guardian',
      },
      {
        value: 'other',
        label: 'Other',
      },
    ],
    visible: true,
  },
  {
    fieldId: 'primaryPhone',
    label: 'Primary Phone',
    section: 'General Info',
    order: 5,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'street',
    label: 'Street',
    section: 'Address',
    order: 1,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'apartment',
    label: 'Apartment',
    section: 'Address',
    order: 2,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'city',
    label: 'City/Suburb',
    section: 'Address',
    order: 3,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'country',
    label: 'Country',
    section: 'Address',
    order: 4,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'zip',
    label: 'Zip/Postcode',
    section: 'Address',
    order: 5,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'state',
    label: 'State/Region',
    section: 'Address',
    order: 6,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'firstName',
    label: 'First Name',
    section: 'Emergency Contacts',
    order: 1,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'lastName',
    label: 'Last Name',
    section: 'Emergency Contacts',
    order: 2,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'primaryPhone',
    label: 'Primary Phone',
    section: 'Emergency Contacts',
    order: 3,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'email',
    label: 'Email',
    section: 'Emergency Contacts',
    order: 4,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'authorizePickup',
    label: 'Authorize Pickup',
    section: 'Emergency Contacts',
    order: 5,
    required: false,
    type: 'checkbox',
    visible: true,
  },
  {
    fieldId: 'firstName',
    label: 'First Name',
    section: 'Students',
    order: 1,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'lastName',
    label: 'Last Name',
    section: 'Students',
    order: 2,
    required: true,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'dob',
    label: 'Date of Birth',
    section: 'Students',
    order: 3,
    required: true,
    type: 'date',
    visible: true,
  },
  {
    fieldId: 'gender',
    label: 'Gender',
    section: 'Students',
    order: 4,
    required: true,
    type: 'select',
    visible: true,
    options: Object.values(Gender).map((gender) => ({
      value: gender,
      label: gender,
    })),
  },
  {
    fieldId: 'email',
    label: 'Student Email',
    section: 'Students',
    order: 5,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'primaryPhone',
    label: 'Student Phone',
    section: 'Students',
    order: 6,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'tShirtSize',
    label: 'Costume Size',
    section: 'Students',
    order: 7,
    required: false,
    type: 'select',
    visible: true,
    options: [
      { value: 'Child XS (2-4)', label: 'Child XS (2-4)' },
      { value: 'Child S (4-6)', label: 'Child S (4-6)' },
      { value: 'Child M (6-8)', label: 'Child M (6-8)' },
      { value: 'Child L (8-10)', label: 'Child L (8-10)' },
      { value: 'Child XL (12-14)', label: 'Child XL (12-14)' },
      { value: 'Adult XS', label: 'Adult XS' },
      { value: 'Adult S', label: 'Adult S' },
      { value: 'Adult M', label: 'Adult M' },
      { value: 'Adult L', label: 'Adult L' },
      { value: 'Adult XL', label: 'Adult XL' },
      {
        value: 'Not Sure, Need Sizing Help',
        label: 'Not Sure, Need Sizing Help',
      },
    ],
  },
  {
    fieldId: 'transportation',
    label: 'Transportation',
    section: 'Students',
    order: 8,
    required: false,
    type: 'radio',
    visible: true,
  },
  {
    fieldId: 'healthInsuranceCarrier',
    label: 'Health Insurance Carrier',
    section: 'Students',
    order: 9,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'primaryDoctor',
    label: 'Primary Doctor',
    section: 'Students',
    order: 10,
    required: false,
    type: 'text',
    visible: true,
  },
  {
    fieldId: 'allergies',
    label: 'Allergies',
    section: 'Students',
    order: 11,
    required: false,
    type: 'text-area',
    visible: true,
  },
  {
    fieldId: 'disabilities',
    label: 'Disabilities',
    section: 'Students',
    order: 12,
    required: false,
    type: 'text-area',
    visible: true,
  },
  {
    fieldId: 'medications',
    label: 'Medications',
    section: 'Students',
    order: 13,
    required: false,
    type: 'text-area',
    visible: true,
  },
  {
    fieldId: 'specialNeeds',
    label: 'Special Needs',
    section: 'Students',
    order: 14,
    required: false,
    type: 'text-area',
    visible: true,
  },
  {
    fieldId: 'enrollments',
    label: 'Enrollments',
    section: 'Students',
    order: 15,
    required: true,
    type: 'select',
    visible: true,
  },
];
